import { render, staticRenderFns } from "./customAudioSlider.vue?vue&type=template&id=159a183d&scoped=true&"
import script from "./customAudioSlider.vue?vue&type=script&lang=js&"
export * from "./customAudioSlider.vue?vue&type=script&lang=js&"
import style0 from "./customAudioSlider.vue?vue&type=style&index=0&id=159a183d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a183d",
  null
  
)

export default component.exports